<template>
	<div style="display: flex; flex-direction: column; gap: 40px">
		<Card>
			<CardGrafico
				:loading="dashboardStore.getters.isEmpty"
				:title="$t('plantedArea')"
				:subtitle="`Última atualização em ${new Date(
					dashboardStore.state.datasMedicao[0],
				).toLocaleDateString('pt-BR', {
					month: 'long',
					day: 'numeric',
					year: 'numeric',
				})}`"
			>
				<template #grafico>
					<div
						style="
							display: flex;
							justify-content: space-between;
							align-items: center;
							padding: 0.5rem 0;
						"
					>
						<div style="display: flex; gap: 1rem; align-items: center">
							<v-date-picker
								v-model="dashboardStore.state.dataEscolhida"
								mode="date"
								color="green"
								:model-config="{ type: 'string' }"
								:update-on-input="false"
								:available-dates="dashboardStore.state.datasMedicao"
							>
								<template #default="{ inputValue, inputEvents }">
									<div
										style="
											width: fit-content;
											border: 1px solid #ccc;
											border-radius: 5px;
											padding: 0.5rem;
											margin: 1rem 0;
										"
									>
										<i
											class="fas fa-calendar-alt"
											style="
												padding-right: 0.5rem;
												color: #72a313;
												border-right: 1px solid #ccc;
												margin-right: 0.5rem;
											"
										/>
										<input
											:value="inputValue"
											v-on="inputEvents"
										/>
									</div>
								</template>
							</v-date-picker>
							<ButtonDropdown
								v-model="unidade"
								:options="[
									{ value: 'dap', label: i18n.t('hbd') },
									{ value: 'ht', label: 'HT' },
									{ value: 'volumeComCasca', label: i18n.t('volume') },
								]"
								style="width: fit-content"
							/>
						</div>
						<div style="display: flex; gap: 1rem">
							<Checkbox
								v-model="showInfoPlantio"
								:label="$t('informacoesPlantio')"
							/>
							<Checkbox
								v-model="showAmostras"
								:label="$t('exibirAmostras')"
							/>
						</div>
					</div>
					<div style="display: flex; gap: 1.5rem">
						<GmapMap
							ref="mapa"
							:options="{ disableDefaultUI: true }"
							style="height: auto; width: -webkit-fill-available; min-height: 90%"
							map-type-id="satellite"
							class="container__googlemaps__position"
							:center="{ lat: -17.390269, lng: -40.538804 }"
							:zoom="16"
						>
							<template #visible>
								<div
									style="
										height: 100%;
										width: fit-content;
										margin: 1rem 0.5rem;
										position: absolute;
										display: flex;
										flex-direction: column;
										align-items: center;
									"
								>
									<p
										style="
											font-size: 0.8rem;
											margin: 0;
											display: flex;
											flex-direction: column;
											border-radius: 5px;
											padding: 0.2rem;
											align-items: center;
											font-weight: bold;
											color: white;
										"
									>
										<span>{{ maxValue }}</span>
										<span>{{ suffix[unidade] }}</span>
									</p>
									<div
										style="
											height: 33%;
											width: 100%;
											background-image: linear-gradient(
												to bottom,
												#385622,
												#a6d08e,
												#f9db69,
												#fe0201
											);
											border: 1px solid white;
										"
									/>
									<p
										style="
											font-size: 0.8rem;
											margin: 0;
											display: flex;
											flex-direction: column;
											border-radius: 5px;
											padding: 0.2rem;
											align-items: center;
											font-weight: bold;
											color: white;
										"
									>
										<span>{{ minValue }}</span>
										<span>{{ suffix[unidade] }}</span>
									</p>
								</div>
							</template>

							<!-- Plota limites de fazendas  -->
							<PolygonShape
								v-for="fazenda in dashboardStore.state.dashboardData?.fazendas"
								:key="fazenda.id"
								:editable="false"
								:options="{
									fillColor: 'transparent',
									strokeColor: 'white',
									strokeOpacity: 1,
									zIndex: 0,
									strokeWeight: 1,
									fillOpacity: 0.4,
								}"
								:coordinates="JSON.parse(fazenda.geojson).coordinates"
								:type="JSON.parse(fazenda.geojson).type"
								:clickable="true"
							/>

							<PolygonShape
								v-for="(coordinateAndType, index) in dashboardStore.getters.getMedicoes"
								:key="index"
								:editable="false"
								:options="{
									fillColor: getPlantioColor(coordinateAndType.plantioId),
									strokeColor: 'transparent',
									strokeOpacity: 1,
									zIndex: 0,
									strokeWeight: 1,
									fillOpacity: 1,
								}"
								:coordinates="JSON.parse(coordinateAndType.geojson).coordinates"
								:type="JSON.parse(coordinateAndType.geojson).type"
								:properties="coordinateAndType.properties"
								:clickable="true"
							/>

							<div v-if="showInfoPlantio">
								<div
									v-for="fazenda in dashboardStore.state.dashboardData?.fazendas"
									:key="fazenda.id"
								>
									<PlantioMarker
										v-for="(plantioMarker, index) in dashboardStore.getters.getMedicoes"
										:key="`${index}-plantioMarker`"
										:plantio-marker="
											Object.assign(
												{
													codigo: plantioMarker.codigo,
													htMedio: plantioMarker.ht,
													volumeMedio: plantioMarker.volumeComCasca,
													materialGenetico: plantioMarker.materialGenetico,
													dapMedio: plantioMarker.dap,
													espacamento: plantioMarker.espacamento,
													area: plantioMarker.area,
													infoPoligono: {
														centroId: {
															coordinates: center(JSON.parse(plantioMarker.geojson)).geometry
																.coordinates,
														},
													},
												},
												plantioMarker,
											)
										"
									/>
								</div>
							</div>

							<div v-if="showAmostras">
								<GmapMarker
									v-for="amostra in dashboardStore.state.dashboardData.amostras"
									:key="amostra.id"
									:position="{
										lat: Number(amostra.latitude),
										lng: Number(amostra.longitude),
									}"
									:clickable="true"
									:draggable="false"
									:icon="{
										title: `Amostra`,
										path: 0,
										fillColor: 'blue',
										fillOpacity: 1,
										strokeColor: 'white',
										strokeWeight: 0.5,
										scale: 5,
										draggable: true,
									}"
									@click="amostraInfo = amostra.id"
								>
									<GmapInfoWindow
										v-if="amostraInfo === amostra.id"
										:opened="true"
									>
										<div style="display: flex; flex-direction: column; gap: 1rem">
											<span>Amostra: {{ amostra.codigo }}</span>
											<span>MAC: {{ amostra.mac }}</span>
										</div>
									</GmapInfoWindow>
								</GmapMarker>
							</div>
						</GmapMap>
						<ChartFilter
							:filters="filtros"
							:options="variaveisCustomizadasOptions"
							@fazendas="fazendasEscolhidas = $event"
							@espacamento="espacamentosEscolhidos = $event"
							@material="materiaisEscolhidos = $event"
							@plantio="plantiosEscolhidos = $event"
						/>
					</div>
				</template>
			</CardGrafico>
		</Card>
	</div>
</template>

<script setup>
import { bbox, center, featureCollection } from '@turf/turf'
import chroma from 'chroma-js'
import { computed, onMounted, ref, watch } from 'vue'
import i18n from '../../../VueI18n'
import ButtonDropdown from '../../../components/ButtonDropdown/ButtonDropdown.vue'
import Card from '../../../components/Card/Card.vue'
import CardGrafico from '../../../components/CardGrafico/CardGrafico.vue'
import ChartFilter from '../../../components/ChartFilter/ChartFilter.vue'
import Checkbox from '../../../components/Checkbox/Checkbox.vue'
import PolygonShape from '../../../components/Map/PolygonShape'
import PlantioMarker from '../../../components/PlantioMarker/PantioMarker.vue'
import { useStore } from '../../../store/modules/moduleDashboardAnalytics'
import { getDropdownEstratosFlorestais } from '../../../services/requests/EstratoFlorestalRequests'

const amostraInfo = ref(undefined)

const dashboardStore = useStore()

// Mapeamento de estratos (ID -> Nome)
const estratosMap = ref({})
const estratosLoaded = ref(false)

const fazendasEscolhidas = ref([])
const espacamentosEscolhidos = ref([])
const plantiosEscolhidos = ref([])
const materiaisEscolhidos = ref([])
const mapa = ref(undefined)
const unidade = ref(undefined)
const showInfoPlantio = ref(false)
const showAmostras = ref(false)
const suffix = ref({
	dap: ' cm',
	ht: ' m',
	volumeComCasca: ' m³/ha',
})

// Carregar estratos imediatamente (antes do mount)
const carregarEstratos = async () => {
	try {
		const estratos = await getDropdownEstratosFlorestais()
		const novoMap = {}
		estratos.forEach((estrato) => {
			novoMap[estrato.id] = `EF-${estrato.esfl_cd_codigo} - ${estrato.esfl_ds_descricao}`
		})
		estratosMap.value = novoMap
		estratosLoaded.value = true
	} catch (error) {
		console.error('Erro ao carregar estratos:', error)
		estratosLoaded.value = true
	}
}

// Inicia o carregamento imediatamente
carregarEstratos()

const plantiosGeojsonBbox = computed(() => {
	return bbox(
		featureCollection(
			dashboardStore.getters.getMedicoes.map(({ geojson }) => {
				return { type: 'Feature', geometry: JSON.parse(geojson), properties: {} }
			}),
		),
	)
})

const bounds = computed(() => {
	const coords = ['west', 'south', 'east', 'north']
	const bboxs = dashboardStore.state.dashboardData ? plantiosGeojsonBbox.value : [0, 0, 0, 0]
	return Object.fromEntries(
		bboxs.map((m, i) => {
			return [coords[i], m]
		}),
	)
})

onMounted(() => {
	unidade.value = 'volumeComCasca'
	console.log('medicoes: ', dashboardStore.getters.getMedicoes)
})

watch([mapa, bounds], ([value]) => {
	value.$mapPromise.then((map) => {
		map.fitBounds(bounds.value, 0)
	})
})

function getPlantioColor(plantioId) {
	const plantio = dashboardStore.getters.getMedicoes.find(
		(medicao) => medicao.plantioId === plantioId,
	)
	const medicoesByFazenda = dashboardStore.getters.getMedicoes
		.filter((medicao) => medicao.fazendaId === plantio.fazendaId)
		.sort((a, b) => (a[unidade.value] > b[unidade.value] ? 1 : -1))
	const colors = chroma
		.scale(['#385622', '#a6d08e', '#f9db69', '#fe0201'])
		.colors(medicoesByFazenda.length)

	return colors[medicoesByFazenda.indexOf(plantio)]
}

const minValue = computed(() => {
	return Math.min(...dashboardStore.getters.getMedicoes.map((medicao) => medicao[unidade.value]))
})
const maxValue = computed(() => {
	return Math.max(...dashboardStore.getters.getMedicoes.map((medicao) => medicao[unidade.value]))
})

const variaveisCustomizadasOptions = computed(() => {
	const variaveisExistentes = dashboardStore.state.dashboardData
		? [
				...new Set(
					dashboardStore.state.dashboardData.fazendas
						.map((fazenda) => {
							return fazenda.dadosNivelPlantio
								.map((plantio) => {
									return plantio.variavelCustomizada || []
								})
								.flat()
						})
						.flat()
						.filter((m) => m !== null && m !== undefined)
						.map((m) => m.name),
				),
			]
		: []

	// Adiciona "Estrato" como opção se houver estratos carregados
	if (estratosLoaded.value && Object.keys(estratosMap.value).length > 0) {
		variaveisExistentes.push('Estrato')
	}

	return variaveisExistentes
})

const filtros = computed(() => {
	return {
		fazendas: dashboardStore.state.dashboardData
			? dashboardStore.state.dashboardData.fazendas.map((dado) => {
					return { nome: dado.nome, id: dado.id }
				})
			: [],
		plantios: dashboardStore.state.dashboardData
			? dashboardStore.state.customizada === 'Estrato'
				? // Se for Estrato, busca os estratos únicos das medições
					[
						...new Set(
							dashboardStore.getters.getMedicoes
								.map((medicao) => {
									return estratosMap.value[medicao.estratoFlorestalId] || medicao.estratoFlorestalId
								})
								.filter((estrato) => estrato !== undefined && estrato !== null),
						),
					]
				: // Caso contrário, busca nas variáveis customizadas normais
					[
						...new Set(
							dashboardStore.state.dashboardData.fazendas
								.map((dado) => dado.dadosNivelPlantio)
								.flat()
								// .filter(filtraPorFazenda)
								.map((plantio) =>
									dashboardStore.state.customizada
										? plantio.variavelCustomizada?.find(
												(v) => v.name === dashboardStore.state.customizada,
											)?.value
										: undefined,
								)
								.filter((v) => v !== undefined && v !== null)
								.flat(),
						),
					]
			: [],
		espacamentos: dashboardStore.state.dashboardData
			? [
					...new Set(
						dashboardStore.state.dashboardData.fazendas
							.map((dado) => dado.dadosNivelPlantio)
							.flat()
							// .filter(filtraPorFazenda)
							.map((plantio) => plantio.espacamento),
					),
				]
			: [],
		materiaisGenetico: dashboardStore.state.dashboardData
			? [
					...new Set(
						dashboardStore.state.dashboardData.fazendas
							.map((dado) => dado.dadosNivelPlantio)
							.flat()
							// .filter(filtraPorFazenda)
							.map((plantio) => plantio.materialGenetico),
					),
				]
			: [],
	}
})
</script>
